<template>
  <!-- 点数弹窗 -->
  <div class="modal-wrap" v-show="modalstatus">
    <membertc v-if="dialogVisible2" @closemember="closemember"></membertc>
    <div class="pointbox" v-show="pointbox">
      <i class="el-icon-close" @click="closepoint"></i>
      <div class="titlebox">
        <p class="title">
          <span>{{ point }}</span
          >点数
        </p>
        <p class="subtitle">AI点数可用于AI写作等功能</p>
      </div>
      <div class="taskbox">
        <p class="title">点数任务</p>
        <ul>
          <li>
            <div class="msgtitle">
              <p>邀请好友注册</p>
              <p><img src="@/assets/sidebar/piont.png" alt="" />+3</p>
            </div>
            <p class="msgsubtitle">
              好友注册成功，你和Ta都能获得 <span>3点</span>
            </p>
          </li>
          <li>
            <el-button
              type="primary"
              round
              size="medium"
              @click="
                pointbox = false;
                invitebox = true;
              "
              >去邀请</el-button
            >
          </li>
        </ul>
        <ul>
          <li>
            <div class="msgtitle">
              <p>绑定手机号</p>
              <p><img src="@/assets/sidebar/piont.png" alt="" />+3</p>
            </div>
            <p class="msgsubtitle">绑定成功后，下次可以用手机号登录</p>
          </li>
          <li>
            <el-button
              type="primary"
              round
              size="medium"
              @click="phonestatus = true"
              >去绑定</el-button
            >
          </li>
        </ul>
        <ul>
          <li>
            <div class="msgtitle">
              <p>升级VIP，免费畅享AI功能</p>
            </div>
            <p class="msgsubtitle">无限额度、不限字数使用AI写作</p>
          </li>
          <li>
            <el-button
              class="button"
              size="medium"
              round
              @click.stop="showmember"
              >去升级</el-button
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="invitebox" v-show="invitebox">
      <el-scrollbar>
        <i
          class="el-icon-close"
          @click="
            invitebox = false;
            slidePageStatus = false;
            pointbox = true;
          "
        ></i>
        <div class="titlebox">
          <img
            src="@/assets/sidebar/title-b24a3619.png"
            alt=""
            class="titleimg"
          />
          <img
            src="@/assets/sidebar/sub_title-0f328bf3.png"
            alt=""
            class="subtitleimg"
          />
        </div>
        <div class="msgbox">
          <div class="border left">
            <div class="profit">
              <p class="msgboxtitle">邀好友注册成功</p>
              <div>
                <p class="num">3</p>
                <p>
                  <img src="@/assets/sidebar/down.png" alt="" />
                  <span>AI点</span>
                </p>
              </div>
              <p>双方各得<span>点数奖励</span></p>
            </div>
          </div>
          <div><i class="el-icon-plus"></i></div>
          <div class="border right">
            <div class="profit">
              <p class="msgboxtitle">好友首次购买会员</p>
              <div>
                <span class="num">20</span>
                <span class="orange">%</span>
              </div>
              <p>你可得买会员金额的</p>
            </div>
          </div>
        </div>

        <div class="rulesbox">
          <p>每成功邀请一位好友，双方各得3个AI点</p>
          <p>好友首次购买会员，您可获得20%金额返佣</p>
          <p>购会员好友越多，奖励比例可升级至25%*</p>
          <div @click="slidePageStatus = true">查看我的奖励</div>
        </div>

        <div class="tip">
          *如果达成10个被邀好友购买会员的条件，则从第11个起，返佣比例升级至25%；如果您有更多推广资源，可联系客服单独议价
        </div>

        <div class="activityBox">
          <p class="title">活动规则</p>
          <div class="content">
            <p>
              1.
              分享您的邀请链接给好友，当Ta通过链接注册成功后，您和Ta各获得3个AI点数
            </p>
            <p>
              2.
              好友首次购买{{website.web_title}}会员，您将获得Ta支付金额的20%佣金奖励；当购买人数超过10人后，第11人开始，佣金比例上调为25%
            </p>
            <p>3. 好友购买成功30天后方可提现，发生退款后收益无效</p>
            <p>4. 佣金收益超过30元，可联系客服申请提现</p>
            <p>5. 本活动长期有效，最终解释权归广州康桥信息技术有限公司所有</p>
          </div>
        </div>

        <div class="fixed-bottom">
          <div @click="copy($event)">分享给好友</div>
        </div>

        <div class="slidePage" v-show="slidePageStatus">
          <div class="header">
            <i class="el-icon-arrow-left" @click="slidePageStatus = false"></i>
            <p
              :class="slidePageIndex ? 'this' : ''"
              @click="slidePageIndex = true"
            >
              现金奖励
            </p>
            <p
              :class="slidePageIndex ? '' : 'this'"
              @click="slidePageIndex = false"
            >
              点数奖励
            </p>
          </div>
          <div class="tip">数据并非实时更新，可能会有延后</div>
          <div v-show="slidePageIndex" class="slidepage1">
            <div class="income">
              <div class="incomeheader">
                <p>
                  <span>可提现收益</span>
                  <span>好友购买30天后可提现</span>
                </p>
                <p>
                  <span>￥</span><span>{{ income.income1 }}</span>
                </p>
              </div>
              <div class="incomebody">
                <ul>
                  <li>
                    <p>待确定收益</p>
                    <p>0</p>
                  </li>
                  <li>
                    <p>已提现收益</p>
                    <p>0</p>
                  </li>
                  <li>
                    <p>累计收益</p>
                    <p>0</p>
                  </li>
                </ul>
              </div>
              <div class="incomefooter">
                <p>可提现收益超过30元可申请提现</p>
                <p>提现</p>
              </div>
            </div>

            <div class="empty">
              <img src="@/assets/sidebar/no_profit-8f5a7003.png" alt="" />
              <p>暂无记录，快去邀请好友吧</p>
            </div>
          </div>
          <div v-show="!slidePageIndex">
            <div class="empty">
              <img src="@/assets/sidebar/no_profit-8f5a7003.png" alt="" />
              <p>暂无记录，快去邀请好友吧</p>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </div>

    <div class="modal-wrap" v-show="phonestatus">
      <div class="phonebox">
        <div class="phonemsg">
          <p>绑定手机号</p>
          <p>首次绑定可以获赠AI点数哦</p>
          <div class="phone">
            <el-input
              maxlength="11"
              placeholder="请输入手机号"
              v-model="form.mobile"
            >
              <span slot="prefix">+86</span>
            </el-input>
          </div>
          <div class="codebox">
            <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            <el-button :disabled="disabled ? true : false" @click="smsSendV2">{{
              text
            }}</el-button>
          </div>
          <el-button
            type="primary"
            class="submit"
            @click="userBindMobileForCenter"
            style="width: 100%"
            >绑定</el-button
          >
        </div>
        <div class="close" @click="phonestatus = false">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var _this;
import membertc from "@/components/membertc";
import {
  getAccountSetting,
  userBindMobileForCenter,
  smsSendV2,
} from "@/api/user";
import { validatePhoneNumber } from "@/utils/commom";
import Clipboard from 'clipboard'
export default {
  components: {
    membertc,
  },
  props: {
    modalstatus: {
      default: false,
    },
  },
  data() {
    return {
		website: this.$store.website,
      text: "发送验证码",
      second: 60,
      form: {
        code: "",
        mobile: "",
      },
      phonestatus: false,
      dialogVisible2: false,
      point: 20,
      pointbox: true,
      invitebox: false,
      slidePageStatus: false,
      slidePageIndex: true,
      income: {
        income1: 0,
        income2: 0,
        income3: 0,
        income4: 0,
      },
    };
  },
  mounted() {
    _this = this;
  },
  methods: {
    showmember(){
      this.dialogVisible2 = true
      // this.closepoint()
    },
    copy(event) {
        const clipboard = new Clipboard(event.target, {
            text: () => this.$store.userInfo.invite_text
        })
        clipboard.on('success', () => {
            clipboard.destroy()
            this.$message({
                message: '复制成功',
                type: 'success',
                duration: 3 * 1000
            })
        })
        clipboard.on('error', () => {
            clipboard.destroy()
            this.$message({
                message: '复制失败',
                type: 'error',
                duration: 3 * 1000
            })
        })
        clipboard.onClick(event)	
    },
    closemember() {
      this.dialogVisible2 = false;
    },
    closepoint() {
      this.pointbox = true;
      this.$emit("closepoint", false);
      this.$canScroll();
    },
    userBindMobileForCenter() {
      userBindMobileForCenter(_this.form).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
          _this.phonestatus = false;
        }
      });
    },
    smsSendV2() {
      if (!validatePhoneNumber(_this.form.mobile)) {
        _this.$message.error("手机号码格式错误");
        return false;
      }
      smsSendV2({ mobile: _this.form.mobile }).then((res) => {
        _this.disabled = true;
        let time = setInterval(() => {
          _this.text = _this.second + "s";
          _this.second--;
          if (_this.second == 0) {
            _this.second = 60;
            _this.disabled = false;
            clearInterval(time);
          }
        }, 1000);
      });
    },
  },
};
</script>

<style lang="less">
.modal-wrap {
  // width: 100vw;
  // height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  .pointbox {
    width: 360px;
    border-radius: 16px;
    background: url(../../assets/sidebar/pc_get_points_bg-296b09d8.png)
      no-repeat;
    background-color: #f4f5f7;
    position: relative;
    overflow: hidden;
    z-index: 1999;
    i {
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 22px;
      cursor: pointer;
      color: #1d2129;
    }
    .titlebox {
      padding: 24px 20px;
      .title {
        color: #3b3b3b;
        font-size: 22px;
        line-height: 1;
        span {
          color: #3b3b3b;
          line-height: 1;
          font-size: 32px;
        }
      }
      .subtitle {
        color: #7c85a1;
        font-size: 13px;
        font-weight: 400;
        margin-top: 6px;
      }
    }
    .taskbox {
      border-radius: 16px 16px 0 0;
      background: #fff;
      padding: 16px 20px;
      .title {
        color: #3b3b3b;
        font-size: 14px;
        font-weight: 400;
      }
      .button {
        background: linear-gradient(104deg, #fff1d9 3.56%, #fee4b6 88.21%);
        color: #613f1a;
        border: none;
      }
      ul {
        display: flex;
        justify-content: space-between;
        margin-top: 12px;
        margin-bottom: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid #f4f5f7;
        .msgtitle {
          display: flex;
          p:nth-child(1) {
            margin-right: 4px;
            color: #3b3b3b;
            font-size: 16px;
          }
          p:nth-child(2) {
            display: flex;
            padding: 1px 8px;
            justify-content: center;
            align-items: center;
            gap: 2px;
            border-radius: 21px;
            background: #eaeefe;
            color: #827cff;
            font-size: 12px;
            font-weight: 400;
            img {
              width: 1em;
              height: 1em;
            }
          }
        }
        .msgsubtitle {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          margin-top: 4px;
          span {
            color: #2d8af5;
          }
        }
      }
      ul:last-child {
        margin-bottom: 0;
        // padding-bottom: 0;
        border-bottom: none;
      }
    }
  }

  .invitebox {
    .el-scrollbar{
        width: 100%;
        height: 100%;
        .el-scrollbar__wrap{
            overflow-x: hidden;
            .el-scrollbar__view{
                padding-bottom: 84px;
            }
        }
    }
    width: 480px;
    height: 95vh;
    padding: 60px 24px 20px;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(../../assets/sidebar/bg-a2358bbb.png);
    border-radius: 16px;
    overflow: hidden;
    z-index: 2001;
    position: relative;
    .el-icon-close {
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 22px;
      cursor: pointer;
      color: #1d2129;
      z-index: 2000;
    }
    .titlebox {
      img {
        display: block;
      }
      .titleimg {
        width: 254px;
        margin: 0 auto;
      }
      .subtitleimg {
        width: 300px;
        margin: 12px auto 0;
      }
    }
    .msgbox {
      display: flex;
      align-items: center;
      // padding: 0 20px;
      margin-top: 16px;
      justify-content: space-between;
      i {
        font-size: 18px;
        color: #fb8a45;
      }
      .border {
        height: 154px;
        width: calc(50% - 10px);
        background: #ffffff;
        border-radius: 12px;
        border: 2px solid #0c5cf8;
        box-shadow: 0 2.7004px 10.8016px rgba(98, 170, 252, 0.26);
        text-align: center;
        cursor: pointer;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .left {
        .profit {
          div {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0;
            span {
              display: block;
              font-size: 13px;
              font-weight: 700;
              text-align: left;
            }
            img {
              display: block;
              width: 50px;
            }
          }
        }
      }
      .right {
        .profit {
          div {
            margin: 10px 0;
          }
          .orange {
            color: #f5663e;
          }
        }
      }
      .msgboxtitle {
        font-size: 16px;
        font-weight: 700;
      }
      .num {
        font-size: 40px;
        font-weight: 700;
        color: #f5663e;
      }
    }

    .rulesbox {
      margin: 20px 0 0;
      padding: 20px;
      width: 100%;
      height: 120px;
      border-radius: 12px;
      background: #ffffff;
      box-shadow: inset -4px -4px 13px rgba(51, 133, 255, 0.2),
        inset 4px 4px 13px rgba(51, 133, 255, 0.2);
      font-size: 14px;
      color: #233049;
      p {
        height: 32px;
        border-bottom: 1px dashed #e2e2e2;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      div {
        width: 160px;
        height: 48px;
        font-weight: 700;
        background: linear-gradient(180deg, #fdb96a -2.08%, #fd8039 110.94%);
        box-shadow: 0 2px 11px rgba(168, 115, 255, 0.15);
        border-radius: 48px;
        color: #fff;
        font-size: 16px;
        align-items: center;
        justify-content: center;
        margin: 14px auto 0;
        display: flex;
      }
    }

    .tip {
      color: #999;
      font-size: 10px;
      line-height: 14px;
      margin-top: 8px;
      text-align: center;
    }

    .activityBox {
      margin-top: 20px;
      width: 100%;
      padding: 20px;
      background-color: #fff;
      border-radius: 12px;
      text-align: left;
      .title {
        color: #101834;
        font-weight: 700;
        font-size: 14px;
      }
      .content {
        p {
          color: #666;
          font-size: 12px;
          line-height: 150%;
          margin-top: 8px;
        }
      }
    }

    .fixed-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 12px 20px 20px;
      background-color: #fff;
      div {
        color: #fff;
        background: linear-gradient(180deg, #3591fd 5.19%, #205efa 100%),
          #00c777;
        cursor: pointer;
        width: 100%;
        height: 52px;
        border-radius: 12px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .slidePage {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1999;
      background-color: #fff;
      .header {
        height: 60px;
        background-color: #fff;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        p {
          padding: 0 16px;
          color: #333;
          font-size: 14px;
          position: relative;
          cursor: pointer;
        }
        .el-icon-arrow-left {
          position: absolute;
          top: 20px;
          left: 20px;
          font-size: 20px;
          cursor: pointer;
        }
        .this {
          color: #2d8af5;
          font-weight: 700;
        }
        .this::after {
          content: "";
          height: 2px;
          width: 40px;
          background: #2d8af5;
          display: block;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -10px;
        }
      }
      .tip {
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f9f2ec;
        color: #d3895f;
        font-size: 12px;
      }
      .slidepage1 {
        background: #f4f5f7;
        color: #020713;
        height: calc(100% - 82px);
        padding: 16px 20px;
        .income {
          filter: drop-shadow(0px 0px 8px rgba(221, 84, 41, 0.2));
          background-size: cover;
          background-repeat: no-repeat;
          width: 100%;
          border: 1px solid rgba(255, 255, 255, 0.85);
          border-radius: 8px;
          background: linear-gradient(
            285.97deg,
            #ffd1a7 0.44%,
            #f7e9d5 70.2%,
            #f7e9d3 107.33%
          );
          margin-bottom: 16px;
          .incomeheader {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #fff;
            padding: 12px 0;
            margin: 0 20px;
            p:nth-child(1) {
              span {
                display: block;
              }
              span:nth-child(1) {
                color: #9a4438;
                font-size: 16px;
                font-weight: 700;
                margin-bottom: 2px;
              }
              span:nth-child(2) {
                color: #9a4438;
                font-size: 12px;
                line-height: 17px;
              }
            }
            p:nth-child(2) {
              color: #a21515;
              span:nth-child(1) {
                font-size: 12px;
                font-weight: 700;
              }
              span:nth-child(2) {
                font-size: 30px;
                font-weight: 700;
              }
            }
          }
          .incomebody {
            padding: 12px 20px;
            ul {
              display: flex;
              justify-content: space-between;
              text-align: center;
              li {
                flex: 0 0 33.3%;
                p:nth-child(1) {
                  color: #825656;
                  font-size: 12px;
                  margin-bottom: 6px;
                }
                p:nth-child(2) {
                  color: #825656;
                  font-weight: 700;
                  font-size: 20px;
                }
              }
            }
          }
          .incomefooter {
            height: 40px;
            background: rgba(255, 255, 255, 0.2);
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            p:nth-child(1) {
              color: #9a4438;
              font-size: 12px;
            }
            p:nth-child(2) {
              height: 28px;
              width: 64px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              font-weight: 700;
              color: #8a1d1d;
              background: #ffffff;
              border-radius: 18px;
            }
          }
        }
      }
    }
    .empty {
      margin-top: 80px;
      text-align: center;
      img {
        width: 70px;
      }
      p {
        text-align: center;
        margin-top: 16px;
        font-size: 12px;
        color: #999;
      }
    }
  }
  .modal-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    .phonebox {
      .wechatmsg {
        width: 340px;
        height: 326px;
        background: #ffffff;
        border-radius: 12px;
      }
      .phonemsg {
        width: 340px;
        height: 326px;
        background: #ffffff;
        border-radius: 12px;
        padding: 44px 25px;
        p:nth-child(1) {
          font-style: normal;
          font-weight: 700;
          font-size: 20px;
          line-height: 26px;
          color: #1d2129;
          text-align: center;
        }
        p:nth-child(2) {
          font-weight: 400;
          font-size: 12px;
          line-height: 16px;
          color: #999;
          margin-bottom: 27px;
          margin-top: 4px;
          text-align: center;
        }
        .phone {
          .el-input__inner {
            padding-left: 60px;
          }
          .el-input__prefix {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 60px;
            color: rgb(144, 147, 153);
            font-size: 12px;
            letter-spacing: 1px;
            // position: relative;
          }
          .el-input__prefix::after {
            content: "";
            width: 0.5px;
            height: 16px;
            background-color: #e5e8ef;
            margin-left: 8px;
          }
        }

        .codebox {
          margin: 24px 0;
          display: flex;
          justify-content: space-between;
          .el-button {
            margin-left: 20px;
          }
        }
      }
    }
    .close {
      width: 28px;
      height: 28px;
      font-size: 16px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px auto 0;
      cursor: pointer;
    }
  }
}
</style>